import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';

import { FC, PropsWithChildren } from 'react';

import { IModalContentStageFillingProps } from './types';

import * as styles from './ModalContentStageFilling.css';

export const ModalContentStageFilling: FC<PropsWithChildren<IModalContentStageFillingProps>> = props => {
  const { description, title, children } = props;

  return (
    <div>
      <div className={styles['title-container']}>
        <ArticleHeading2 as="span" color="black_100" fontWeight="bold">
          {title}
        </ArticleHeading2>
      </div>
      <ArticleParagraph1 as="span" color="black_100" fontWeight="normal">
        {description}
      </ArticleParagraph1>
      <div className={styles['form-container']}>{children}</div>
    </div>
  );
};

ModalContentStageFilling.displayName = 'ModalContentStageFilling';
